// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/baloa-pro-background-full.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-header__container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 378px;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 64px;
}

.baloa-pro-header__container.baloa-pro {
    padding-top: 140px;
}

.baloa-pro-header__content {
    max-width: 726px;
    margin-left: 30%;
}

.baloa-pro-header__title {
    display: flex;
    align-items: center;
    justify-content: center;
}

.baloa-pro-header__title .hubicon-award_star {
    font-size: 50px;
    margin-right: 18px;
}

.baloa-pro-header__title .baloa-headline-1 {
    font-size: var(--space-x3);
    font-weight: var(--font-bold);
    color: var(--white-color);
}

.baloa-pro-header__title-message {
    color: var(--white-color);
    font-size: 20px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-regular);
    letter-spacing: -0.3px;
    line-height: normal;
    text-align: center;
    margin-top: 24px;
}

.baloa-pro-header__title-price {
    color: var(--white-color);
    font-size: 20px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-regular);
    letter-spacing: -0.3px;
    line-height: normal;
    text-align: center;
}

.baloa-pro-header__buttons {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 44px;
    justify-content: center;
}

.baloa-pro-header__buttons .button {
    font-family: 'Lexend Deca';
    padding: var(--space-half-quarter);
}

.baloa-pro-header__buttons .button span {
    text-transform: none;
}

.baloa-pro-header__buttons .secondary-button {
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    padding: var(--space-half-quarter);
}

.baloa-pro-header__content .baloa-username {
    color: var(--white-color);
    margin-top: 12px;
    text-align: center;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-header__container {
        height: 181px;
        padding-top: 41px;
        background-position: 15%;
    }
    
    .baloa-pro-header__container.baloa-pro {
        padding-top: 65px;
    }
    
    .baloa-pro-header__content {
        max-width: 726px;
        margin-left: 50%;
    }

    .baloa-pro-header__title .hubicon-award_star {
        font-size: 24px;
        margin-right: 6px;
    }

    .baloa-pro-header__title {
        justify-content: flex-start;
    }
    
    .baloa-pro-header__title .baloa-headline-1 {
        font-size: 20px;
        font-weight: var(--font-bold);
    }

    .baloa-pro-header__title-message {
        font-size: 13px;
        margin-top: 8px;
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-header/BaloaProHeaderComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,yDAAoE;IACpE,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yDAAyD;IACzD,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,aAAa;QACb,iBAAiB;QACjB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".baloa-pro-header__container {\n    background-image: url('assets/images/baloa-pro-background-full.png');\n    height: 378px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 64px;\n}\n\n.baloa-pro-header__container.baloa-pro {\n    padding-top: 140px;\n}\n\n.baloa-pro-header__content {\n    max-width: 726px;\n    margin-left: 30%;\n}\n\n.baloa-pro-header__title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.baloa-pro-header__title .hubicon-award_star {\n    font-size: 50px;\n    margin-right: 18px;\n}\n\n.baloa-pro-header__title .baloa-headline-1 {\n    font-size: var(--space-x3);\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n}\n\n.baloa-pro-header__title-message {\n    color: var(--white-color);\n    font-size: 20px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-regular);\n    letter-spacing: -0.3px;\n    line-height: normal;\n    text-align: center;\n    margin-top: 24px;\n}\n\n.baloa-pro-header__title-price {\n    color: var(--white-color);\n    font-size: 20px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-regular);\n    letter-spacing: -0.3px;\n    line-height: normal;\n    text-align: center;\n}\n\n.baloa-pro-header__buttons {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 44px;\n    justify-content: center;\n}\n\n.baloa-pro-header__buttons .button {\n    font-family: 'Lexend Deca';\n    padding: var(--space-half-quarter);\n}\n\n.baloa-pro-header__buttons .button span {\n    text-transform: none;\n}\n\n.baloa-pro-header__buttons .secondary-button {\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    padding: var(--space-half-quarter);\n}\n\n.baloa-pro-header__content .baloa-username {\n    color: var(--white-color);\n    margin-top: 12px;\n    text-align: center;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-header__container {\n        height: 181px;\n        padding-top: 41px;\n        background-position: 15%;\n    }\n    \n    .baloa-pro-header__container.baloa-pro {\n        padding-top: 65px;\n    }\n    \n    .baloa-pro-header__content {\n        max-width: 726px;\n        margin-left: 50%;\n    }\n\n    .baloa-pro-header__title .hubicon-award_star {\n        font-size: 24px;\n        margin-right: 6px;\n    }\n\n    .baloa-pro-header__title {\n        justify-content: flex-start;\n    }\n    \n    .baloa-pro-header__title .baloa-headline-1 {\n        font-size: 20px;\n        font-weight: var(--font-bold);\n    }\n\n    .baloa-pro-header__title-message {\n        font-size: 13px;\n        margin-top: 8px;\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
